export default "__VITE_ASSET__D2L3WdVa__"